/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type Period = typeof Period[keyof typeof Period];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Period = {
  Other: 'Other',
  Past5Years: 'Past5Years',
  _2019: '_2019',
  _2020: '_2020',
  _2021: '_2021',
  _2022: '_2022',
  _2023: '_2023',
  _2024: '_2024',
  _2025: '_2025',
  _2026: '_2026',
  _2027: '_2027',
  _2028: '_2028',
  _2029: '_2029',
  _2030: '_2030',
  _2031: '_2031',
  _2032: '_2032',
  _2033: '_2033',
  _2034: '_2034',
  _2035: '_2035',
  _2036: '_2036',
  _2037: '_2037',
  _2038: '_2038',
  _2039: '_2039',
  _2040: '_2040',
} as const;
